export class CustomerBasicProperties {
    Id: number;
    CustomerNumber: string;
    BillToNumber: string;
    Name: string;
}
